export const ORDER_SEGMENTS = {
  COLLECTED_SAMPLES: { val: "collectedSamples", heading: "Collected Samples" },
  APPROVED_SAMPLES: { val: "approvedSamples", heading: "Approved Samples" },
  CONFIRM_SHIPMENT: { val: "confirmShipment", heading: "Confirm Shipment" }
};
